// DateUtils.js


const formatDate = (timestamp) => {
    if (!timestamp) return null;

  // Step 1: Convert the timestamp string to a proper ISO UTC format
  const utcTimestamp = timestamp.replace(' ', 'T') + 'Z'; // "2025-06-25T08:00:00.604Z"

  // Step 2: Create the date object
  const date = new Date(utcTimestamp); // This is now treated as UTC

  // Step 3: Format in Asia/Dubai (Gulf Standard Time)
  return date.toLocaleString('en-GB', {
    timeZone: 'Asia/Dubai',
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};
export { formatDate };


const convertUTCToLocal = (utcString) => {
  if (!utcString || typeof utcString !== "string") return null;

  // Ensure space is replaced with 'T' and append 'Z' for UTC
  const isoFormatted = utcString.replace(" ", "T") + "Z";
  const parsedDate = new Date(isoFormatted);

  if (isNaN(parsedDate.getTime())) {
    console.error("❌ Invalid Date:", utcString);
    return null;
  }

  return parsedDate; // Or customize using options or locale
};

export { convertUTCToLocal };

const convertUTCToLocalFromDate = (utcString) => {
  if (!utcString || typeof utcString !== "string") return "";

  const isoFormatted = utcString.replace(" ", "T") + "Z";
  const parsedDate = new Date(isoFormatted);

  if (isNaN(parsedDate.getTime())) return "";

  return parsedDate.toLocaleString(); // ✅ string output
};

export { convertUTCToLocalFromDate };

const safeFormatDateOnly = (value) => {
  if (!value) return '—';
  try {
    let dateVal;
    if (typeof value === 'string') {
      if (value.endsWith('Z') || value.includes('+') || (value.includes('T') && !value.endsWith('Z'))) {
        dateVal = new Date(value);
      } else {
        const utcTimestamp = value.replace(' ', 'T') + (value.endsWith('Z') ? '' : 'Z');
        dateVal = new Date(utcTimestamp);
      }
    } else {
      dateVal = new Date(value);
    }

    if (isNaN(dateVal.getTime())) {
      return String(value);
    }

    return dateVal.toLocaleString('en-GB', {
      timeZone: 'Asia/Dubai',
      year: 'numeric',
      month: 'short',
      day: '2-digit',
    });
  } catch (e) {
    console.error("Error formatting date:", value, e);
    return String(value);
  }
};
export { safeFormatDateOnly };